
import { Union, Record } from "./fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { FormState__setValidationResponse_5219762A, FormState_get_empty, ClientApiResponse$1_$reflection, FormState_$reflection } from "./Shared/Shared.js";
import { union_type, class_type, string_type, record_type, bool_type } from "./fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Cmd_none } from "./fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_OfPromise_either } from "./fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "./CommunicationV2.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { ofArray } from "./fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "./fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { defaultOf } from "./fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { createElement } from "react";
import React from "react";
import { useAuth } from "react-oidc-context";
import { React_useElmish_Z6C327F2E } from "./fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "./fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "./fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "./fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import User_Add_Plus from "../public/assets/icons/User_Add_Plus.svg";
import { TextValue, PageHeader } from "./Components/Text.js";
import { singleton, delay, toList } from "./fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { TextButton } from "./Components/Button.js";

class State extends Record {
    constructor(FormState, AccountCreated) {
        super();
        this.FormState = FormState;
        this.AccountCreated = AccountCreated;
    }
}

function State_$reflection() {
    return record_type("CreateAccount.State", [], State, () => [["FormState", FormState_$reflection()], ["AccountCreated", bool_type]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CreateAccount", "AccountCreated", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("CreateAccount.Msg", [], Msg, () => [[], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

function init() {
    return [new State(FormState_get_empty(), false), Cmd_none()];
}

function update(msg, state) {
    switch (msg.tag) {
        case 1: {
            const response_1 = msg.fields[0];
            if (response_1.tag === 1) {
                return [new State(FormState__setValidationResponse_5219762A(state.FormState, response_1.fields[0]), state.AccountCreated), Cmd_none()];
            }
            else {
                return [new State(state.FormState, true), Cmd_none()];
            }
        }
        case 2:
            return [state, Cmd_none()];
        default:
            return [state, Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_2;
                return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                    const pr = response.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                }, refreshOn)))(true);
            })), ["/api/users/account", defaultOf()], (Item) => (new Msg(1, [Item])), (Item_1) => (new Msg(2, [Item_1])))];
    }
}

export function CreateAccountPage() {
    let elems_5, elems_4, elems, elems_1, elems_2, elems_3;
    const auth = useAuth();
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init, update, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full", "flex", "justify-center", "content-center", "bg-background"])], (elems_5 = [reactElement("div", createObj(ofArray([["className", join(" ", ["grow", "max-w-lg", "my-auto", "p-6", "flex", "flex-col", "border", "border-border", "rounded-md", "bg-[#FFFFFF]"])], (elems_4 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mx-auto", "w-24", "h-24", "mb-4"])], (elems = [User_Add_Plus()], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["mx-auto", "mb-5", "mt-8"])], (elems_1 = [createElement(PageHeader, {
        Text: t("create_account.title"),
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["mx-auto", "mb-5"])], (elems_2 = [createElement(TextValue, {
        FontWeight: "normal",
        TestId: "",
        Text: state_1.AccountCreated ? t("create_account.description_success") : t("create_account.description"),
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "items-center", "gap-5"])], (elems_3 = toList(delay(() => (state_1.AccountCreated ? singleton(createElement(TextButton, {
        ComponentState: "enabled",
        Label: t("create_account.account_created_redirect"),
        OnClick: () => {
            auth.removeUser();
            window.location.href = window.location.origin;
        },
        TestId: "",
        Variant: "blueButton",
    })) : singleton(createElement(TextButton, {
        ComponentState: "enabled",
        Label: t("create_account.create_account"),
        OnClick: () => {
            patternInput[1](new Msg(0, []));
        },
        TestId: "",
        Variant: "blueButton",
    }))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

